import Vue from 'vue';
import Router from 'vue-router';
import PatchEditor from '@/components/canvas/PatchEditor.vue';
import store from './store/index';

import AppLayout from './pages/AppLayout.vue';
import LoginPage from './pages/LoginPage.vue';
import JacketPage from './pages/JacketPage.vue';
import PatchesPage from './pages/PatchesPage.vue';
import FinalizePage from './pages/FinalizePage.vue';

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters['auth/isLoggedIn']) {
    next();
    return;
  }
  next({ path: '/', query: to.query });
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters['auth/isLoggedIn']) {
    next({ path: to });
    return;
  }
  console.log(to);
  next({ path: '/login', query: to.query });
};

export default new Router({
  mode: 'history',
  base: '/',

  routes: [
    {
      path: '/',
      name: 'AppLayout',
      component: Vue.component('AppLayout', AppLayout),
      redirect: '/jacket',
      beforeEnter: ifAuthenticated,

      children: [
        {
          path: '/jacket',
          name: 'JacketPage',
          component: Vue.component('AppLayout', JacketPage),
          beforeEnter: ifAuthenticated,
        },
        {
          path: '/patches',
          name: 'PatchesPage',
          component: Vue.component('AppLayout', PatchesPage),
          beforeEnter: ifAuthenticated,
        },
        {
          path: '/finalize',
          name: 'FinalizePage',
          component: Vue.component('AppLayout', FinalizePage),
          beforeEnter: ifAuthenticated,
        },
      ],
    },

    {
      path: '/login',
      name: 'LoginPage',
      component: Vue.component('LoginPage', LoginPage),
      beforeEnter: ifNotAuthenticated
    },

    {
      path: '/patchEditor',
      name: 'PatchEditor',
      component: Vue.component('PatchEditor', PatchEditor),
      beforeEnter: ifAuthenticated,
    },

    {
      path: '/insertEditor',
      name: 'InsertEditor',
      component: Vue.component('InsertEditor', PatchEditor),
      beforeEnter: ifAuthenticated,
    },
  ],
});
